import { createModal } from '/@/core/elements/modal'
import type {
  ProjectVisibility,
  ProjectClientType,
  ProjectProductDisplayType,
  ProjectStatus,
  ProjectType,
  ProjectThingsLayout,
} from '/@/common/projects/types'

export interface ProjectData {
  type?: 'new' | 'existing'
  projectType?: ProjectType

  // if existing
  id?: string

  // if new
  name?: string

  // settings
  visibility?: ProjectVisibility
  clientType?: ProjectClientType
  productDisplayType?: ProjectProductDisplayType
  status?: ProjectStatus
  nickname?: string
  canViewProjectHub?: boolean
  taxPercentage?: number
  markupPercentage?: number
  thingsLayout?: ProjectThingsLayout
}

export type ProjectModalTabType = 'create new' | 'existing project'

export interface StartProjectModalData {
  projectId: string | null
}

const { api: useStartProjectModal, component: StartProjectModal } =
  createModal<StartProjectModalData>(
    'StartProjectModal',
    () => import('./StartProjectModal.vue'),
    {
      projectId: null,
    },
  )

export { StartProjectModal, useStartProjectModal }
